import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { BrowserRouter as Router } from "react-router-dom";
import Intercom from "@intercom/messenger-js-sdk";
import Routes from "./routes";
import "./App.css";

function App() {

  Intercom({
    app_id: "ldb3yt7w",
  });

  window.intercomSettings = {
    app_id: "ldb3yt7w",
    hide_default_launcher: window.innerWidth <= 768,
  };
  
  
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div className="App">
          <Routes />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
